var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/tooltip",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999785,3.53128688 C16.8148627,3.53128688 20.7187078,7.43653956 20.7187078,12.2500161 C20.7187078,17.0663079 16.8148627,20.9687453 11.9999785,20.9687453 C7.18509439,20.9687453 3.28124933,17.0663079 3.28124933,12.2500161 C3.28124933,7.43653956 7.18509439,3.53128688 11.9999785,3.53128688 Z M11.9999785,7.39846516 C11.1844859,7.39846516 10.5234196,8.05953155 10.5234196,8.87502414 C10.5234196,9.69051673 11.1844859,10.3515831 11.9999785,10.3515831 C12.8154711,10.3515831 13.4765375,9.69051673 13.4765375,8.87502414 C13.4765375,8.05953155 12.8154711,7.39846516 11.9999785,7.39846516 Z M13.9687238,16.3281314 L13.9687238,15.4843834 C13.9687238,15.2514051 13.7798281,15.0625094 13.5468499,15.0625094 L13.1249759,15.0625094 L13.1249759,11.5468928 C13.1249759,11.3139145 12.9360801,11.1250188 12.7031019,11.1250188 L10.4531072,11.1250188 C10.220129,11.1250188 10.0312332,11.3139145 10.0312332,11.5468928 L10.0312332,12.3906408 C10.0312332,12.623619 10.220129,12.8125148 10.4531072,12.8125148 L10.8749812,12.8125148 L10.8749812,15.0625094 L10.4531072,15.0625094 C10.220129,15.0625094 10.0312332,15.2514051 10.0312332,15.4843834 L10.0312332,16.3281314 C10.0312332,16.5611096 10.220129,16.7500054 10.4531072,16.7500054 L13.5468499,16.7500054 C13.7798281,16.7500054 13.9687238,16.5611096 13.9687238,16.3281314 Z",
    id: "tooltip",
    fill: "#8B9799",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.372025d7.svg";
export { ForwardRef as ReactComponent };